import { Grid, useMediaQuery } from "@mui/material";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import React from "react";
import { useDispatch } from "react-redux";
import Color from "../../../assets/colors";
import * as config from "../../../config/config";
import { updateContactUsEmployer } from "../../../redux/actions/dialog_action";
import {
  BoxContainer,
  ButtonStyled,
  CheckIconStyled,
  ColumnContainer,
  ContactContainer,
  EmptyIconStyled,
  FilmIconStyled,
  GradientText,
  GroupIconStyled,
  HeartIconStyled,
  ImageStyled,
  InnerColumnContainer,
  OutlineButtonStyled,
  PurpleStyled,
  RowContainer,
  SectionContainer,
  SparklesIconStyled,
  TextStyled,
  TitleContainer,
  TitleSpan,
  TitleText,
} from "./styles";

function EmployerLandingProduct() {
  const isDesktop = useMediaQuery("(min-width:1280px)");
  const isTablet = useMediaQuery("(min-width:640px)");
  const dispatch = useDispatch();

  const comparisonItem = [
    "Free internship posts",
    "Flexibly swap jobs at no additional cost",
    "Media-rich company profile to tell your story",
    "Expand reach across an extensive network of job boards",
    "AI-enabled application screening and resume summarization",
    "Enhanced performance with automated job ads",
    "Dedicated customer support",
    "Exclusive job ad design - outshine the competition!",
    "Onboarding and product demo session!",
  ];

  const productItem = [
    {
      title: "MOST AFFORDABLE",
      productName: "Job Slot",
      productType: "",
      imageSrc: "/images/employer_landing/product-job-slot.webp",
      headerColor: "#EFEFEF",
      headerTextColor: "rgba(0, 0, 0, 0.87)",
      columnColor: "#FFFFFF",
      borderColor: "#EFEFEF",
      borderRadius: "0.625rem 0 0 0.625rem",
      checkAmount: 5,
      onboarding: "Virtual Group",
    },
    {
      preTitle: "1.5X",
      title: "PERFORMANCE",
      productName: "Job Slot",
      productType: "Plus",
      imageSrc: "/images/employer_landing/product-job-slot-plus.webp",
      headerColor:
        "linear-gradient(270deg, #8468D9 0%, #966DD5 45.87%, #B376CD 101.73%);",
      headerTextColor: "rgba(255, 255, 255, 0.87)",
      columnColor: "rgba(247, 247, 254, 1)",
      borderColor: "#512ACC1A",
      borderRadius: 0,
      checkAmount: 6,
      onboarding: "Virtual 1:1",
    },
    {
      preTitle: "2.2X",
      title: "PERFORMANCE",
      productName: "Job Slot",
      productType: "Max",
      imageSrc: "/images/employer_landing/product-job-slot-max.webp",
      headerColor: "linear-gradient(90deg, #6EC7CD 18.57%, #B0CD72 96.74%)",
      headerTextColor: "rgba(255, 255, 255, 0.87)",
      columnColor: "#F6FBF8",
      borderColor: "#6EC197",
      borderRadius: "0 0.625rem 0.625rem 0",
      checkAmount: 8,
      onboarding:
        process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "sg"
          ? "Virtual 1:1"
          : "Onsite",
    },
  ];

  const personalisedItem = {
    title: "PERSONALISED",
    productName: "Not quite what you’re looking for?",
    imageSrc: "/images/employer_landing/product-personalised.webp",
    headerColor: Color?.lightPurple,
    headerTextColor: "rgba(0, 0, 0, 0.87)",
    borderColor: "#EFEFEF",
    columnColor: "#FFFFFF",
    text: [
      {
        __html:
          "Let us help you mix and match based on your needs for a personalised solution!",
      },
      {
        icon: <GroupIconStyled />,
        __html: "<b>Mix and match </b> what you want on your job ad space",
      },
      {
        icon: <HeartIconStyled />,
        __html:
          "Make your company attractive to top talents with <b> enticing content</b>",
      },
      {
        icon: <FilmIconStyled />,
        __html:
          "Don’t have a photographer/ videographer? Leave all the<b> creative </b>stuff to us",
      },
    ],
  };

  const [refStart, entryStart] = useIntersectionObserver({
    threshold: isDesktop ? 0.72 : 0.9,
  });

  const [refStop, entryStop] = useIntersectionObserver({});

  const isVisible = entryStart?.isIntersecting;
  const isHide = entryStop?.isIntersecting;

  function triggerInfoDialog() {
    dispatch(updateContactUsEmployer({ state: true }));
  }

  return (
    <SectionContainer>
      <BoxContainer flexDirection={"column"}>
        {/* <TextStyled
          variant={"h2"}
          fontSize={isDesktop ? "2.625rem" : isTablet ? "1.5625rem" : "1.25rem"}
          fontWeight={"700"}
          lineHeight={"1.875rem"}
          textAlign={"center"}
          marginBottom={isDesktop ? "3.125rem" : isTablet ? "1.25rem" : "1rem"}
        >
          Job Ads Made <PurpleStyled>Simple</PurpleStyled>
        </TextStyled> */}
        {!isDesktop ? (
          <TextStyled
            fontSize={isTablet && "16px"}
            fontWeight={"600"}
            marginBottom={isTablet && "16px"}
          >
            Compare our Job Ad Solutions
          </TextStyled>
        ) : null}
      </BoxContainer>
      {isDesktop ? (
        <BoxContainer gap={"0.5rem"}>
          <BoxContainer flexDirection={"column"} paddingRight={"1.25rem"}>
            <TitleContainer backgroundColor="blue">
              <TitleText>
                Job Ads Made <TitleSpan>Simple</TitleSpan>
              </TitleText>
            </TitleContainer>

            <InnerColumnContainer marginTop={"1.5rem"}>
              <TextStyled
                variant="h5"
                fontSize="1.25rem"
                fontWeight={700}
                marginBottom={"1.5rem"}
              >
                Compare our Job Ad Solutions
              </TextStyled>
            </InnerColumnContainer>
            {comparisonItem.map((item, index) => (
              <InnerColumnContainer key={index}>
                <TextStyled fontSize="0.875rem">{item}</TextStyled>
              </InnerColumnContainer>
            ))}
          </BoxContainer>

          {productItem?.map((item, index) => (
            <ColumnContainer
              key={index}
              bgcolor={item?.columnColor}
              borderRadius={"10px"}
              border={"1px solid" + item?.borderColor}
            >
              {/* SCROLLING HEADER */}
              <BoxContainer
                flexDirection={"column"}
                marginBottom={"-93px"}
                position={"sticky"}
                top={"0px"}
                sx={{ opacity: isVisible ? 0 : isHide ? 1 : 0 }}
              >
                <BoxContainer
                  sx={{ background: item?.headerColor }}
                  color={item?.headerTextColor}
                  alignContent={"center"}
                  justifyContent={"center"}
                  padding={"0.5rem"}
                >
                  {item?.preTitle ? (
                    <TextStyled
                      fontSize={"0.75rem"}
                      fontWeight={600}
                      letterSpacing={"1.5px"}
                      textAlign={"center"}
                    >
                      {item?.preTitle + "\u00A0"}
                    </TextStyled>
                  ) : null}
                  <TextStyled
                    fontSize={"0.625rem"}
                    fontWeight={600}
                    letterSpacing={"1.5px"}
                    textAlign={"center"}
                    padding={"0.125rem 0"}
                  >
                    {item?.title}
                  </TextStyled>
                </BoxContainer>
                <TextStyled
                  bgcolor={item?.columnColor}
                  fontSize="1rem"
                  fontWeight={700}
                  textAlign={"center"}
                  whiteSpace={"nowrap"}
                  padding={"0.625rem 0 1.5rem"}
                >
                  {item?.productName + " "}
                  <GradientText
                    component={"span"}
                    sx={{
                      background: item?.headerColor,
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    {item?.productType}
                  </GradientText>
                </TextStyled>
              </BoxContainer>

              <BoxContainer
                sx={{ background: item?.headerColor }}
                color={item?.headerTextColor}
                alignContent={"center"}
                justifyContent={"center"}
                padding={"0.5rem"}
              >
                {item?.preTitle ? (
                  <TextStyled
                    fontSize={"0.75rem"}
                    fontWeight={600}
                    letterSpacing={"1.5px"}
                    textAlign={"center"}
                  >
                    {item?.preTitle + "\u00A0"}
                  </TextStyled>
                ) : null}
                <TextStyled
                  fontSize={"0.625rem"}
                  fontWeight={600}
                  letterSpacing={"1.5px"}
                  textAlign={"center"}
                  padding={"0.125rem 0"}
                >
                  {item?.title}
                </TextStyled>
              </BoxContainer>
              <BoxContainer
                flexDirection={"column"}
                alignItems={"center"}
                padding={"0.625rem 1.25rem 1.25rem"}
              >
                <ImageStyled
                  src={config?.assetDomain + item?.imageSrc}
                  height={120}
                  width={120}
                  ref={refStart}
                />
                <InnerColumnContainer
                  key={index}
                  flexDirection={"column"}
                  justifyContent={"center"}
                >
                  <TextStyled
                    fontSize="1rem"
                    fontWeight={700}
                    textAlign={"center"}
                    whiteSpace={"nowrap"}
                    marginBottom={"1.5rem"}
                  >
                    {item?.productName + " "}
                    <GradientText
                      component={"span"}
                      sx={{
                        background: item?.headerColor,
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      {item?.productType}
                    </GradientText>
                  </TextStyled>
                </InnerColumnContainer>

                {Array.from({ length: item?.checkAmount }).map((_, index) =>
                  index === 5 ? (
                    <InnerColumnContainer
                      key={index}
                      justifyContent={"center"}
                      ref={refStop}
                    >
                      <CheckIconStyled />
                    </InnerColumnContainer>
                  ) : (
                    <InnerColumnContainer key={index} justifyContent={"center"}>
                      <CheckIconStyled />
                    </InnerColumnContainer>
                  )
                )}

                {Array.from({ length: 8 - item?.checkAmount }).map((index) => (
                  <InnerColumnContainer key={index} justifyContent={"center"}>
                    <EmptyIconStyled />
                  </InnerColumnContainer>
                ))}
                <InnerColumnContainer justifyContent={"center"}>
                  <TextStyled
                    color={"rgba(0, 0, 0, 0.60)"}
                    fontSize={"0.875rem"}
                    fontWeight={400}
                    lineHeight={"1.5rem"}
                    letterSpacing={"0.15px"}
                  >
                    {item?.onboarding}
                  </TextStyled>
                </InnerColumnContainer>
                <ContactContainer backgroundColor={item?.columnColor}>
                  <ButtonStyled onClick={triggerInfoDialog}>
                    Contact us
                  </ButtonStyled>
                </ContactContainer>
              </BoxContainer>
            </ColumnContainer>
          ))}

          <ColumnContainer
            borderRadius={"10px"}
            border={"1px solid" + personalisedItem?.borderColor}
          >
            {/* SCROLL HEADER */}
            <BoxContainer
              flexDirection={"column"}
              marginBottom={"-95px"}
              position={"sticky"}
              top={"0px"}
              sx={{ opacity: isVisible ? 0 : isHide ? 1 : 0 }}
            >
              <BoxContainer
                bgcolor={personalisedItem?.headerColor}
                color={personalisedItem?.headerTextColor}
                alignContent={"center"}
                justifyContent={"center"}
                gap={"0.5rem"}
                padding={"0.5rem"}
              >
                <SparklesIconStyled />
                <TextStyled
                  fontSize={"0.625rem"}
                  fontWeight={600}
                  letterSpacing={"1.5px"}
                  textAlign={"center"}
                  padding={"0.125rem 0"}
                >
                  {personalisedItem?.title}
                </TextStyled>
                <SparklesIconStyled />
              </BoxContainer>
              <TextStyled
                bgcolor={personalisedItem?.columnColor}
                color={Color?.darkPurple}
                fontSize="1rem"
                fontWeight={700}
                textAlign={"center"}
                whiteSpace={"wrap"}
                lineHeight={"1.25rem"}
                padding={"0.625rem 0"}
              >
                {personalisedItem?.productName}
              </TextStyled>
            </BoxContainer>

            <BoxContainer
              bgcolor={personalisedItem?.headerColor}
              color={personalisedItem?.headerTextColor}
              alignContent={"center"}
              justifyContent={"center"}
              gap={"0.5rem"}
              padding={"0.5rem"}
            >
              <SparklesIconStyled />
              <TextStyled
                fontSize={"0.625rem"}
                fontWeight={600}
                letterSpacing={"1.5px"}
                textAlign={"center"}
                padding={"0.125rem 0"}
              >
                {personalisedItem?.title}
              </TextStyled>
              <SparklesIconStyled />
            </BoxContainer>
            <BoxContainer
              flexDirection={"column"}
              justifyContent={"space-between"}
              padding={"0.625rem 0.625rem 1.25rem"}
              height={"100%"}
            >
              <BoxContainer flexDirection={"column"} alignItems={"center"}>
                <ImageStyled
                  src={config?.assetDomain + personalisedItem?.imageSrc}
                  height={120}
                  width={120}
                />
                <TextStyled
                  fontSize="1rem"
                  fontWeight={700}
                  color={Color?.darkPurple}
                  textAlign={"center"}
                  margin={"0.3125rem 0 2rem"}
                >
                  {personalisedItem?.productName}
                </TextStyled>

                <BoxContainer flexDirection={"column"} gap={"1.875rem"}>
                  {personalisedItem?.text.map((item, index) => (
                    <BoxContainer
                      flexDirection={"column"}
                      alignItems={"center"}
                      gap={"0.5rem"}
                    >
                      {item?.icon}
                      <TextStyled
                        key={index}
                        fontSize={"0.75rem"}
                        fontWeight={400}
                        lineHeight={"1.25rem"}
                        textAlign={"center"}
                        dangerouslySetInnerHTML={item}
                      />
                    </BoxContainer>
                  ))}
                </BoxContainer>
              </BoxContainer>
              <ContactContainer backgroundColor={personalisedItem?.columnColor}>
                <ButtonStyled onClick={triggerInfoDialog}>
                  Contact us
                </ButtonStyled>
              </ContactContainer>
            </BoxContainer>
          </ColumnContainer>
        </BoxContainer>
      ) : (
        <BoxContainer
          flexDirection={"column"}
          marginTop={isTablet ? "auto" : "38px"}
        >
          {/* SCROLLING HEADER */}
          <RowContainer
            position={"sticky"}
            top={"0px"}
            marginBottom={"-5.5rem"}
            sx={{ opacity: isVisible ? 0 : isHide ? 1 : 0 }}
          >
            {productItem?.map((item, index) => (
              <BoxContainer
                key={index}
                flexDirection={"column"}
                alignItems={"center"}
                justifyContent={"space-between"}
                bgcolor={item?.columnColor}
                border={"1px solid" + item?.borderColor}
                borderRadius={item?.borderRadius}
              >
                <BoxContainer
                  sx={{
                    background: item?.headerColor,
                    flexDirection: isTablet ? "row" : "column",
                  }}
                  color={item?.headerTextColor}
                  justifyContent={"center"}
                  alignItems={"center"}
                  height={"1.75rem"}
                  padding={"0 0.5rem"}
                >
                  {item?.preTitle ? (
                    <TextStyled
                      fontSize={isTablet ? "0.75rem" : "0.5rem"}
                      fontWeight={600}
                      letterSpacing={"1.5px"}
                      textAlign={"center"}
                    >
                      {item?.preTitle + " "}
                    </TextStyled>
                  ) : null}
                  <TextStyled
                    fontSize={isTablet ? "0.625rem" : "0.5rem"}
                    fontWeight={600}
                    letterSpacing={"1.5px"}
                    textAlign={"center"}
                    padding={isTablet ? "0.125rem 0.5rem" : "0"}
                    whiteSpace={"wrap"}
                  >
                    {item?.title}
                  </TextStyled>
                </BoxContainer>
                <TextStyled
                  fontSize={isTablet ? "1rem" : "0.875rem"}
                  fontWeight={700}
                  textAlign={"center"}
                  whiteSpace={"nowrap"}
                  padding={isTablet ? "0.625rem 0 1.5rem" : "0 0 0.5rem"}
                >
                  {item?.productName}
                  <GradientText
                    component={"span"}
                    sx={{
                      background: item?.headerColor,
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    {" " + item?.productType}
                  </GradientText>
                </TextStyled>
              </BoxContainer>
            ))}
          </RowContainer>

          <RowContainer marginBottom={"0.625rem"}>
            {productItem?.map((item, index) => (
              <BoxContainer
                key={index}
                flexDirection={"column"}
                alignItems={"center"}
                justifyContent={"space-between"}
                bgcolor={item?.columnColor}
                border={"1px solid" + item?.borderColor}
                borderRadius={item?.borderRadius}
                paddingBottom={"0.5rem"}
              >
                <BoxContainer
                  sx={{
                    background: item?.headerColor,
                    flexDirection: isTablet ? "row" : "column",
                  }}
                  color={item?.headerTextColor}
                  justifyContent={"center"}
                  alignItems={"center"}
                  height={"1.75rem"}
                  padding={"0 0.5rem"}
                >
                  {item?.preTitle ? (
                    <TextStyled
                      fontSize={isTablet ? "0.75rem" : "0.5rem"}
                      fontWeight={600}
                      letterSpacing={"1.5px"}
                      textAlign={"center"}
                    >
                      {item?.preTitle + " "}
                    </TextStyled>
                  ) : null}
                  <TextStyled
                    fontSize={isTablet ? "0.625rem" : "0.5rem"}
                    fontWeight={600}
                    letterSpacing={"1.5px"}
                    textAlign={"center"}
                    padding={isTablet ? "0.125rem 0.5rem" : "0"}
                    whiteSpace={"wrap"}
                  >
                    {item?.title}
                  </TextStyled>
                </BoxContainer>
                <ImageStyled
                  src={config?.assetDomain + item?.imageSrc}
                  style={{ padding: index != 0 ? "0.375rem" : "0" }}
                  ref={refStart}
                />
                <TextStyled
                  fontSize={isTablet ? "1rem" : "0.875rem"}
                  fontWeight={700}
                  textAlign={"center"}
                  whiteSpace={"nowrap"}
                >
                  {!isTablet && item?.productName === "BASIC Job Slot"
                    ? "BASIC"
                    : item?.productName}
                  <GradientText
                    component={"span"}
                    sx={{
                      background: item?.headerColor,
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    {" " + item?.productType}
                  </GradientText>
                </TextStyled>
              </BoxContainer>
            ))}
          </RowContainer>
          {Array.from({ length: 9 }).map((_, mainIndex) => (
            <RowContainer
              key={mainIndex}
              flexDirection={"column"}
              gap={"1.125rem"}
              padding={"1rem 0"}
            >
              {mainIndex === 6 ? (
                <TextStyled
                  fontSize={isTablet ? "1rem" : "0.75rem"}
                  lineHeight={isTablet ? "1.5rem" : "1.25rem"}
                  ref={refStop}
                >
                  {comparisonItem[mainIndex]}
                </TextStyled>
              ) : (
                <TextStyled
                  fontSize={isTablet ? "1rem" : "0.75rem"}
                  lineHeight={isTablet ? "1.5rem" : "1.25rem"}
                >
                  {comparisonItem[mainIndex]}
                </TextStyled>
              )}
              <BoxContainer>
                {productItem?.map((item, index) => (
                  <BoxContainer
                    bgcolor={item?.columnColor}
                    border={"1px solid" + item?.borderColor}
                    borderRadius={item?.borderRadius}
                    alignItems={"center"}
                    justifyContent={"center"}
                    padding={"0.625rem 0"}
                  >
                    {mainIndex + 1 <= item?.checkAmount ? (
                      <CheckIconStyled />
                    ) : mainIndex + 1 === 9 ? (
                      <TextStyled
                        color={"rgba(0, 0, 0, 0.60)"}
                        fontSize={"0.75rem"}
                        fontWeight={400}
                        lineHeight={"1.5rem"}
                        letterSpacing={"0.15px"}
                      >
                        {item?.onboarding}
                      </TextStyled>
                    ) : (
                      <EmptyIconStyled />
                    )}
                  </BoxContainer>
                ))}
              </BoxContainer>
            </RowContainer>
          ))}

          <BoxContainer
            justifyContent={isTablet ? "space-around" : "space-between"}
          >
            <ButtonStyled onClick={triggerInfoDialog}>Contact us</ButtonStyled>
            <ButtonStyled onClick={triggerInfoDialog}>Contact us</ButtonStyled>
            <ButtonStyled onClick={triggerInfoDialog}>Contact us</ButtonStyled>
          </BoxContainer>

          <BoxContainer
            flexDirection={"column"}
            justifyContent={"flex-start"}
            marginTop={"2.25rem"}
          >
            <BoxContainer
              bgcolor={personalisedItem?.headerColor}
              color={personalisedItem?.headerTextColor}
              alignContent={"center"}
              justifyContent={"center"}
              gap={"0.5rem"}
              padding={"0.5rem"}
              borderRadius={"0.625rem 0.625rem 0 0"}
              sx={{ width: isTablet ? "25%" : "50%" }}
            >
              <SparklesIconStyled />
              <TextStyled
                fontSize={"0.625rem"}
                fontWeight={600}
                letterSpacing={"1.5px"}
                textAlign={"center"}
                padding={"0.125rem 0"}
              >
                {personalisedItem?.title}
              </TextStyled>
              <SparklesIconStyled />
            </BoxContainer>
            <BoxContainer
              flexDirection={"column"}
              alignItems={"center"}
              gap={isTablet ? "2rem" : "1.5rem"}
              border={"1px solid" + personalisedItem?.borderColor}
              borderRadius={"0 0.625rem 0.625rem 0.625rem"}
              padding={isTablet ? "1rem" : "0.625rem 0.625rem 1rem"}
            >
              <BoxContainer flexDirection={"column"}>
                <BoxContainer
                  flexDirection={"column"}
                  marginBottom={"1.125rem"}
                  gap={"0.25rem"}
                >
                  <TextStyled
                    color={Color?.darkPurple}
                    fontSize={isTablet ? "1rem" : "0.875rem"}
                    fontWeight={700}
                    lineHeight={isTablet ? "1.5rem" : "1.375rem"}
                  >
                    {personalisedItem?.productName}
                  </TextStyled>
                  <TextStyled
                    fontSize={isTablet ? "0.875rem" : "0.75rem"}
                    fontWeight={400}
                    lineHeight={isTablet ? "1.5rem" : "1.25rem"}
                    dangerouslySetInnerHTML={personalisedItem?.text[0]}
                  />
                </BoxContainer>
                <BoxContainer flexDirection={"column"} gap={"0.625rem"}>
                  {personalisedItem?.text?.slice(1)?.map((item, index) => (
                    <BoxContainer
                      key={index}
                      alignItems={"center"}
                      gap={"0.5rem"}
                    >
                      {item?.icon}
                      <TextStyled
                        key={index}
                        fontSize={isTablet ? "0.875rem" : "0.75rem"}
                        fontWeight={400}
                        lineHeight={isTablet ? "1.5rem" : "1.25rem"}
                        dangerouslySetInnerHTML={item}
                      />
                    </BoxContainer>
                  ))}
                </BoxContainer>
              </BoxContainer>
              <OutlineButtonStyled onClick={triggerInfoDialog}>
                Contact Us
              </OutlineButtonStyled>
            </BoxContainer>
          </BoxContainer>
        </BoxContainer>
      )}
    </SectionContainer>
  );
}

export default EmployerLandingProduct;
